import React from 'react';
import createReactClass from 'create-react-class';
import PropTypes from 'prop-types';
import ImmutableRenderMixin from 'react-immutable-render-mixin';
import ImmutablePropTypes from 'react-immutable-proptypes';
import {Link} from 'react-router';
import {default as Tooltip} from 'components/Tooltip';
import WoffEmbeddedText from 'components/WoffEmbeddedText';
import RemoveTypefaceModal from './RemoveTypefaceModal';

export default createReactClass({
  propTypes: {
    kitToken: PropTypes.string.isRequired,
    workingSetTypeface: ImmutablePropTypes.record.isRequired,
    onRemoveTypeface: PropTypes.func.isRequired,
  },

  mixins: [ImmutableRenderMixin],

  getInitialState() {
    return {
      isFocused: false,
      isRemoving: false,
      showConfirmRemoveModal: false,
      preparingToDelete: false,
    };
  },

  removeWorkingSetTypeface() {
    this.setState({isRemoving: true});

    this.props.onRemoveTypeface(this.props.workingSetTypeface);
  },

  handleFocused() {
    this.setState({isFocused: !this.state.isFocused});
  },

  handleRemoveClicked(event) {
    event.preventDefault();
    event.stopPropagation();

    this.removeWorkingSetTypeface();
  },

  handleConfirmRemoveTypeface(event) {
    event.preventDefault();
    event.stopPropagation();

    this.setState({
      showConfirmRemoveModal: true,
    });
  },

  handleRemoveTypefaceConfirmed() {
    this.removeWorkingSetTypeface();

    this.setState({showConfirmRemoveModal: false});
  },

  handleRemoveTypefaceClosed() {
    this.setState({showConfirmRemoveModal: false});
  },

  handlePreparingToDelete() {
    this.setState({preparingToDelete: true});
  },

  handleNotPreparingToDelete() {
    this.setState({preparingToDelete: null});
  },

  renderFinished() {
    const {kitToken, workingSetTypeface} = this.props;
    const {isFocused, preparingToDelete} = this.state;
    const {family: fontFamily, weight: fontWeight, style: fontStyle} = workingSetTypeface;
    const typefaceName = `${fontFamily} ${fontWeight} ${(fontStyle !== 'normal') ? fontStyle : ''}`;
    const popover = (isFocused && !preparingToDelete) ? <Tooltip icon="ficon-pencil" content={`Edit ${typefaceName}`} /> : null;

    return (
      <Link
        to={`/kits/${kitToken}/typefaces/${workingSetTypeface.id}`}
        className="kit-typeface asset asset-typeface link-dashed-none"
        onMouseOver={this.handleFocused}
        onMouseOut={this.handleFocused}
      >
        {popover}
        <div className="asset-inner">
          <div className="asset-preview">
            <WoffEmbeddedText woff={workingSetTypeface.woff} className="kit-typeface-pangram">
              {typefaceName} - When my six oclock alarm buzzes, I require a pot of good java.
            </WoffEmbeddedText>
          </div>
        </div>

        {this.renderRemoveWorkingSetTypeface(workingSetTypeface)}
      </Link>
    );
  },

  renderRemoveWorkingSetTypeface(workingSetTypeface) {
    const {isFocused, preparingToDelete} = this.state;
    const {family: fontFamily, weight: fontWeight, style: fontStyle} = workingSetTypeface;
    const typefaceName = `${fontFamily} ${fontWeight} ${(fontStyle !== 'normal') ? fontStyle : ''}`;
    const makeDeleteTooltip = () => {
      return (
        <Tooltip
          icon="ficon-times-circle"
          content={`Remove ${typefaceName}`}
        />
      );
    };

    return (
      <div
        className="asset-remove cursor-pointer"
        onClick={(workingSetTypeface.custom) ? this.handleConfirmRemoveTypeface : this.handleRemoveClicked}
        onMouseEnter={this.handlePreparingToDelete}
        onMouseLeave={this.handleNotPreparingToDelete}
      >
        <RemoveTypefaceModal
          show={this.state.showConfirmRemoveModal}
          workingSetTypeface={workingSetTypeface}
          onRemovedTypeface={this.handleRemoveTypefaceConfirmed}
          onClosed={this.handleRemoveTypefaceClosed}
        />

        <div style={{position: 'relative'}}>
          {(isFocused && preparingToDelete) ? makeDeleteTooltip() : null}
          <i className="ficon ficon-times"></i>
        </div>
      </div>
    );
  },

  renderErrored() {
    const {workingSetTypeface} = this.props;

    return (
      <div className="kit-typeface asset asset-error asset-typeface asset-typeface-error br-a p-xs-a-md">
        <div className="asset-inner text-xs-center">
          <span className="inline-block text-danger word-wrap">
            Upload of {workingSetTypeface.name} failed
          </span>
        </div>

        {this.renderRemoveWorkingSetTypeface(workingSetTypeface)}
      </div>
    );
  },

  renderProcessing() {
    const {workingSetTypeface} = this.props;

    return (
      <div className="kit-typeface asset asset-processing asset-typeface asset-typeface-processing br-a p-xs-a-md">
        <div className="asset-inner text-xs-center animated infinite pulseOpacity">
          <i className="ficon ficon-spinner-third ficon-spin ficon-lg block m-xs-r-sm"></i>
          adding {workingSetTypeface.name} &hellip;
        </div>
      </div>
    );
  },

  renderRemoving() {
    const {workingSetTypeface} = this.props;

    return (
      <div className="kit-typeface asset asset-processing asset-typeface asset-typeface-processing br-a p-xs-a-md">
        <div className="asset-inner text-xs-center animated infinite pulseOpacity">
          <i className="ficon ficon-spinner-third ficon-spin ficon-lg block m-xs-r-sm"></i>
          removing {workingSetTypeface.name} &hellip;
        </div>
      </div>
    );
  },

  render() {
    const {workingSetTypeface, kitToken} = this.props;
    const {isRemoving} = this.state;

    let value = null;

    switch (workingSetTypeface.status) {
      case 'finished':
        value = this.renderFinished();
        break;
      case 'errored':
        value = this.renderErrored();
        break;
      default:
        value = this.renderProcessing();
    }

    if (isRemoving) {
      value = this.renderRemoving();
    }

    return value
  },
});



// WEBPACK FOOTER //
// ./app/javascript/views/Kits/components/TypefaceCard.js